// extracted by mini-css-extract-plugin
export default {"dropdownItem":"TenantUsers_dropdownItem__EI4Ou","list":"TenantUsers_list__E9OB+","placeholderImage":"TenantUsers_placeholderImage__Z+adp"};